export const fetchPayloadFromToken = (accessToken: string) => {
  const payloadBase64 = accessToken.split('.')[1]
  const payloadJson = atob(payloadBase64)

  return JSON.parse(payloadJson)
}

export const LOGINAPP = 'login-app'
